var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-flex", { staticClass: "container-full", attrs: { xs12: "" } }, [
    _vm.slideType === "row"
      ? _c(
          "div",
          { staticClass: "slide-bar" },
          [
            _c("v-flex", { attrs: { xs3: "" } }, [
              _c(
                "div",
                {
                  class: {
                    "text-sm-start": _vm.align == "left",
                    "text-xs-right": _vm.align == "right",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.current) +
                      " of " +
                      _vm._s(_vm.total) +
                      "\n      "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("v-flex", { staticClass: "ps-1 pe-1", attrs: { xs9: "" } }, [
              _c("div", { staticClass: "slide-bar-bgr", style: _vm.stylesBg }, [
                _c("div", {
                  staticClass: "slide-bar-progress",
                  style: _vm.styles,
                }),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.slideType === "col"
      ? _c(
          "div",
          { staticClass: "row mx-0 slide-bar" },
          [
            _c("v-flex", { attrs: { md4: "", xs12: "" } }, [
              _c("p", { staticClass: "title m-0" }, [
                _vm._v(_vm._s(_vm.current)),
                _c("span", { staticClass: "small-text" }, [_vm._v("%")]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticClass: "mt-2", attrs: { md8: "", xs12: "" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "slide-bar-bgr float-left",
                    style: _vm.stylesBg,
                  },
                  [
                    _c("div", {
                      staticClass: "slide-bar-progress",
                      style: _vm.styles,
                    }),
                  ]
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }